const uz = {
    meta: {
        title: "Shaxsiy ma'lumotlar qonuni va sayt: 6 ta tekshiruv",
        description:
            "Saytingizdagi forma ZRU-547 talablariga javob beradimi? Rozilik, maxfiylik siyosati, saqlash muddati va lokalizatsiya bo'yicha oltita amaliy tekshiruv.",
        keywords: [
            "shaxsiy ma'lumotlar qonuni sayt O'zbekiston",
            "ZRU-547 shaxsiy ma'lumotlar",
            "maxfiylik siyosati sayt uchun",
            "cookie roziligi O'zbekiston",
            "ma'lumotlar bazasini lokalizatsiya qilish",
            "saytda rozilik belgisi",
        ],
    },
    h1: "Saytingizdagi forma qonunni buzayaptimi: oltita amaliy tekshiruv",
    lead:
        "Sayt orqali telefon raqami yig'adigan har bir kompaniya shaxsiy ma'lumotlarni qayta ishlaydi. Bu maqolada ZRU-547 talablari kontekstida oltita aniq tekshiruv, har birini tuzatish narxi hamda 2026-yil mart oyida lokalizatsiya qoidasiga kiritilgan o'zgarish ko'rib chiqiladi.",
    category: "Qonun va muvofiqlik",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Ko'p sayt egasi «bizda shunchaki aloqa formasi» deb o'ylaydi. Amalda esa o'sha forma orqali ism, telefon va ba'zan manzil yig'iladi, ular CRM ga tushadi, pochtaga ketadi va tahlil skriptlari orqali uchinchi tomonga yo'l oladi.",
        },
        {
            type: "p",
            text:
                "Quyida oltita tekshiruv bor. Ularni bir soat ichida o'zingiz o'tkaza olasiz. Har biri uchun tuzatish hajmi va taxminiy narx ham ko'rsatilgan.",
        },

        { type: "h2", text: "Sayt egasi ham operator hisoblanadimi?" },
        {
            type: "p",
            text:
                "Shaxsiy ma'lumotlar to'g'risidagi ZRU-547 sonli qonun (02.07.2019) shaxsiy ma'lumotlarni qayta ishlashni tartibga soladi. Agar sayt orqali jismoniy shaxsning ismi va telefon raqamini yig'ib, ularni saqlasangiz va ishlatsangiz, siz shu ma'lumotlarni qayta ishlayotgan tomonsiz.",
        },
        {
            type: "p",
            text:
                "Bu holat kompaniya hajmiga bog'liq emas. Uch kishilik studiya ham, yuz kishilik zavod ham bir xil qoidaga bo'ysunadi. Farq faqat hajmda: ma'lumot qancha ko'p bo'lsa, xatoning narxi ham shuncha katta.",
        },
        {
            type: "callout",
            text:
                "Bu maqola yuridik xulosa emas. Qonunning amaldagi tahriri va sizning holatingizga qo'llanilishini yuristingiz bilan tekshiring. Bu yerda texnik va tashkiliy tomon ko'rsatilgan.",
        },

        { type: "h2", text: "Ma'lumotingiz aslida qayerga ketadi" },
        {
            type: "p",
            text:
                "Tipik biznes saytida forma to'ldirilgach, ma'lumot bitta joyda qolmaydi. U kamida to'rt-besh manzilga tarqaladi va ko'pincha sayt egasi bu zanjirning yarmini bilmaydi.",
        },
        {
            type: "ol",
            items: [
                "Forma ma'lumotni saytning serveriga yuboradi va u bazaga yoziladi.",
                "Shu zahoti xabar korporativ pochtaga yoki Telegram guruhiga ketadi.",
                "CRM ga yangi ariza yaratiladi — ko'pincha bu chet eldagi bulut xizmati.",
                "Tahlil skripti va reklama pikseli sahifadagi harakat haqida ma'lumot yuboradi.",
                "Ba'zi saytlarda forma ma'lumoti chatbot yoki qo'ng'iroq xizmatiga ham uzatiladi.",
            ],
        },
        {
            type: "p",
            text:
                "Har bir o'q — bu alohida qaror. Foydalanuvchi bu qarorlarning qaysilariga rozilik berganini bilishi kerak, siz esa buni ko'rsata olishingiz kerak.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Oltita tekshiruv" },
        {
            type: "table",
            head: ["Tekshiruv", "Nimaga qaraysiz", "Tipik muammo"],
            rows: [
                [
                    "1. Rozilik",
                    "Formada belgilanmagan holda turadigan rozilik katagi bormi va matni tushunarlimi",
                    "Katak umuman yo'q yoki oldindan belgilangan",
                ],
                [
                    "2. Maxfiylik siyosati",
                    "Alohida sahifa bormi, unda kim, nimani, qancha muddat va nima uchun to'plashi yozilganmi",
                    "Sahifa boshqa saytdan ko'chirilgan va kompaniyaga aloqasi yo'q",
                ],
                [
                    "3. Saqlash muddati",
                    "Ariza CRM da qancha turadi va uni kim o'chiradi",
                    "Baza 2019-yildan beri hech qachon tozalanmagan",
                ],
                [
                    "4. Uchinchi tomon skriptlari",
                    "Sahifada qaysi tahlil va reklama skriptlari ishlaydi",
                    "Skriptlar rozilikdan oldin yuklanadi",
                ],
                [
                    "5. Ruxsat",
                    "Bazaga kim kira oladi va ishdan ketgan xodimning kirishi yopilganmi",
                    "Hamma menejerda to'liq eksport huquqi bor",
                ],
                [
                    "6. Joylashuv",
                    "Sayt va CRM ma'lumotlari qaysi mamlakatdagi serverda saqlanadi",
                    "Hech kim aniq javob bera olmaydi",
                ],
            ],
        },
        { type: "h3", text: "1-tekshiruv: rozilik matni" },
        {
            type: "p",
            text:
                "Formada rozilik katagi bo'lishi va u oldindan belgilanmagan holda turishi kerak. Matnda ma'lumot nima uchun to'planishi va kimga tegishli ekani aniq yozilsin. «Shartlarga roziman» degan umumiy ibora yetarli emas — foydalanuvchi nimaga rozilik berayotganini bilishi kerak.",
        },
        { type: "h3", text: "2-tekshiruv: maxfiylik siyosati sahifasi" },
        {
            type: "p",
            text:
                "Sahifa saytning o'zida, doimiy havola bilan bo'lsin. Unda kompaniya nomi va rekvizitlari, to'planadigan ma'lumot turlari, maqsad, saqlash muddati va aloqa kanali ko'rsatiladi. Boshqa saytdan ko'chirilgan matn eng ko'p uchraydigan xato: unda ko'pincha boshqa kompaniya nomi qolib ketadi.",
        },
        { type: "h3", text: "3-tekshiruv: saqlash muddati" },
        {
            type: "p",
            text:
                "Ma'lumot cheksiz saqlanmasligi kerak. Amaliy yechim: har bir toifa uchun muddat belgilang — masalan, yopilmagan ariza 12 oy, mijoz kartochkasi shartnoma tugagandan keyin belgilangan muddat. Muddat tugagach, yozuv avtomatik arxivlanadi yoki o'chiriladi.",
        },
        { type: "h3", text: "4-tekshiruv: uchinchi tomon skriptlari" },
        {
            type: "p",
            text:
                "Sahifangizda qaysi skriptlar ishlayotganini brauzerning ishlab chiquvchi panelidan ko'rish mumkin. Ko'p saytda tahlil va reklama skriptlari sahifa ochilishi bilan, hech qanday rozilikdan oldin yuklanadi. To'g'ri yechim — skriptlarni rozilik berilgandan keyin ishga tushirish.",
        },
        { type: "h3", text: "5-tekshiruv: bazaga kimning ruxsati bor" },
        {
            type: "p",
            text:
                "Tekshiring: nechta xodim mijozlar bazasini to'liq eksport qila oladi. Odatda javob kutilganidan katta chiqadi. Rollarni ajrating, eksport huquqini cheklang va ishdan ketgan xodimlarning kirishini yopish ro'yxatga kiritilgan qadam bo'lsin.",
        },
        { type: "h3", text: "6-tekshiruv: ma'lumot qaysi serverda" },
        {
            type: "p",
            text:
                "Sayt hostingi, CRM va pochta xizmatingiz qaysi mamlakatda joylashganini aniq bilib oling. Bu savolga «bilmayman» deb javob berilsa, bu o'zi alohida muammo — chunki keyingi bo'limdagi talab aynan shu javobga bog'liq.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Lokalizatsiya talabi 2026-yilda qanday o'zgardi?" },
        {
            type: "p",
            text:
                "2026-yil 26-martdagi ZRU-1125 sonli qonun bilan ZRU-547 ning 27-1-moddasi yangi tahrirda bayon etildi. Unga ko'ra O'zbekiston hududida majburiy saqlanishi lozim bo'lgan ma'lumotlar ro'yxati aniq belgilangan: jismoniy shaxslarning biometrik ma'lumotlari, genetik ma'lumotlari hamda O'zbekistonda faoliyat yurituvchi telekommunikatsiya operatorlari xizmatlaridan foydalanuvchilarning ma'lumotlari.",
        },
        {
            type: "p",
            text:
                "Qolgan shaxsiy ma'lumotlar qonunda ko'rsatilgan shartlar bajarilganda mamlakatdan tashqarida ham qayta ishlanishi mumkin. Shu bilan birga 20-modda yangi tahrirda majburiy saqlanishi lozim bo'lgan bazalarni Davlat reyestrida ro'yxatdan o'tkazishni nazarda tutadi.",
        },
        {
            type: "p",
            text:
                "Amaliy xulosa oddiy biznes sayti uchun quyidagicha. Agar siz faqat ism va telefon yig'sangiz va biometrik yoki genetik ma'lumot bilan ishlamasangiz, chet el bulutidan foydalanish avtomatik ravishda taqiqlanmaydi — lekin qonundagi shartlarni bajarish talab etiladi. Agar biometrika bilan ishlasangiz, masalan yuz bo'yicha kirish tizimi bo'lsa, savol butunlay boshqacha bo'ladi.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Tuzatish qancha turadi va qancha vaqt oladi?" },
        {
            type: "p",
            text:
                "Quyidagi oraliqlar — Innobek amaliyotidagi tipik ish hajmi. Aniq summa saytingiz qanday qurilgani va CRM turiga bog'liq.",
        },
        {
            type: "table",
            head: ["Ish", "Hajm", "Taxminiy narx"],
            rows: [
                ["Formaga rozilik katagi va tushunarli matn qo'shish", "2–4 soat", "1 mln so'mgacha"],
                ["Maxfiylik siyosati sahifasini joylashtirish va havolalar bilan bog'lash", "4–8 soat", "1–2 mln so'm"],
                ["CRM da saqlash muddati va avtomatik arxivlash qoidasi", "8–16 soat", "2–4 mln so'm"],
                ["Skriptlar auditi va ularni rozilikdan keyin ishga tushirish", "16–40 soat", "4–10 mln so'm"],
                ["Rollar va eksport huquqlarini qayta qurish", "8–24 soat", "2–6 mln so'm"],
                ["Hosting yoki bazani boshqa serverga ko'chirish", "1–3 hafta", "3–8 mln so'm"],
                ["Doimiy texnik qo'llab-quvvatlash", "oylik", "3,5 mln so'mdan / oyiga"],
            ],
        },
        {
            type: "p",
            text:
                "Narxga kirmaydi: yuridik matnni tayyorlash va tekshirish, yangi hosting yoki bulut obunasi, biometrik ma'lumot bilan ishlaydigan tizim uchun alohida talablar. Maxfiylik siyosati matnini yurist yozgani ma'qul — dasturchi uni faqat joylashtiradi.",
        },

        { type: "h2", text: "Jarima qancha? Halol javob" },
        {
            type: "p",
            text:
                "Internetda tarqalgan jarima raqamlari bir-biriga mos kelmaydi va ularning ko'pi bazaviy hisoblash miqdorining eski qiymatiga tayanadi. Shu sababli bu yerda aniq summa keltirmaymiz.",
        },
        {
            type: "p",
            text:
                "To'g'ri qadam boshqa: amaldagi javobgarlik miqdorini va u sizning holatingizga qanday qo'llanilishini yuristingiz bilan tekshiring. Texnik tomondan esa yuqoridagi oltita tekshiruvni bajarish jarimadan qat'i nazar foydali — chunki ular ma'lumot sizib chiqish riskini ham kamaytiradi.",
        },

        { type: "h2", text: "Hech narsa qilmaslikning narxi" },
        {
            type: "list",
            items: [
                "Mijozlar bazasining sizib chiqishi — reputatsiya yo'qotish, buni hech qanday byudjet tez tiklay olmaydi.",
                "Ishdan ketgan menejer bazani eksport qilib ketishi — sotuv voronkangiz raqobatchida paydo bo'ladi.",
                "Korporativ mijoz yoki tender tashkilotchisi maxfiylik siyosatini so'raydi va uning yo'qligi shartnomani to'xtatadi.",
                "Rozilik yozib olinmagan bo'lsa, siz ma'lumotni qonuniy olganingizni isbotlay olmaysiz.",
                "Cheksiz saqlanayotgan baza — bu kerak bo'lmagan ma'lumot uchun ham javobgarlik.",
            ],
        },

        { type: "h2", text: "Bu ish qachon ortiqcha" },
        {
            type: "list",
            items: [
                "Saytingizda umuman forma bo'lmasa va faqat telefon raqami ko'rsatilgan bo'lsa — hozircha bu maqoladagi ishlarning katta qismi kerak emas.",
                "Sayt yaqinda qayta qurilayotgan bo'lsa — eski saytni tuzatmang, talablarni yangisining texnik topshirig'iga kiriting.",
                "Ichkarida mas'ul bo'lmasa — hujjatlar yoziladi, jarayon esa bajarilmaydi. Avval mas'ulni belgilang.",
                "Tahlil skriptlaridan umuman foydalanmasangiz — to'rtinchi tekshiruv sizga tegishli emas.",
                "Bazani boshqa serverga ko'chirishni faqat oltinchi tekshiruv natijasi buni talab qilsa qiling. Aks holda bu ortiqcha xarajat.",
            ],
        },

        { type: "h2", text: "Bir haftalik audit rejasi" },
        {
            type: "ol",
            items: [
                "1-kun: saytdagi barcha formalarni ro'yxatga oling — aloqa, qayta qo'ng'iroq, yuklab olish, obuna.",
                "2-kun: har bir forma ma'lumotini qayerga yuborishini kuzating va zanjirni chizib chiqing.",
                "3-kun: maxfiylik siyosati matnini o'qing va unda boshqa kompaniya nomi qolmaganini tekshiring.",
                "4-kun: CRM dagi eng eski yozuvni toping va saqlash muddati qoidasini yozing.",
                "5-kun: bazaga kirish huquqi bor xodimlar ro'yxatini tuzing va ortiqchalarini yoping.",
                "6-kun: hosting, CRM va pochta xizmatlaringiz qaysi mamlakatda joylashganini yozma aniqlang.",
                "7-kun: natijani yuristga ko'rsating va tuzatish ro'yxatini muhimlik bo'yicha tartiblang.",
            ],
        },
        {
            type: "p",
            text:
                "Eng katta foyda ikkinchi kunda paydo bo'ladi. Ko'p kompaniya o'z ma'lumot zanjirini birinchi marta o'shanda to'liq ko'radi va ortiqcha skriptlarning yarmini o'sha kuniyoq o'chiradi.",
        },
    ],

    faq: [
        {
            q: "Saytimda shunchaki aloqa formasi bor — qonun menga tegishlimi?",
            a: "Ha. Forma orqali jismoniy shaxsning ismi va telefon raqamini yig'ib saqlasangiz, siz shaxsiy ma'lumotlarni qayta ishlayotgan bo'lasiz. Bu kompaniya hajmiga bog'liq emas: uch kishilik studiya ham, yirik zavod ham bir xil qoidaga bo'ysunadi. Farq faqat ma'lumot hajmida va shunga mos risk darajasida.",
        },
        {
            q: "Ma'lumotni O'zbekiston serverida saqlash majburiymi?",
            a: "2026-yil 26-martdagi ZRU-1125 qonuni bilan ZRU-547 ning 27-1-moddasi yangi tahrirda bayon etilgan. Unda majburiy saqlanadigan ma'lumotlar aniq ko'rsatilgan: biometrik, genetik ma'lumotlar va telekommunikatsiya operatorlari foydalanuvchilarining ma'lumotlari. Boshqa ma'lumotlar qonundagi shartlar bajarilganda tashqarida ham qayta ishlanishi mumkin. Amaldagi tahrirni yuristingiz bilan tekshiring.",
        },
        {
            q: "Maxfiylik siyosatini boshqa saytdan ko'chirsam bo'ladimi?",
            a: "Bu eng keng tarqalgan xato. Ko'chirilgan matnda ko'pincha boshqa kompaniya nomi va u ishlatmaydigan xizmatlar qolib ketadi, ya'ni hujjat sizning haqiqiy jarayoningizni tasvirlamaydi. Matn kompaniyangiz rekvizitlari, to'planadigan ma'lumot turlari, maqsad va saqlash muddatini aks ettirishi kerak. Uni yurist tayyorlagani ma'qul, dasturchi esa faqat joylashtiradi.",
        },
        {
            q: "Rozilik katagi oldindan belgilangan bo'lsa bo'ladimi?",
            a: "Yo'q. Rozilik foydalanuvchining ongli harakati bo'lishi kerak, shuning uchun katak belgilanmagan holda turishi lozim. Matn ham tushunarli bo'lsin: ma'lumot nima uchun to'planishi va kimga uzatilishi aniq yozilsin. «Shartlarga roziman» degan umumiy ibora bu talabni qoniqtirmaydi, chunki foydalanuvchi nimaga rozilik berayotganini bilmaydi.",
        },
        {
            q: "Jarima qancha?",
            a: "Ochiq manbalarda tarqalgan raqamlar bir-biriga mos kelmaydi va ko'pi bazaviy hisoblash miqdorining eski qiymatiga tayanadi, shuning uchun biz aniq summa keltirmaymiz. Amaldagi javobgarlik miqdorini va uning sizning holatingizga qo'llanilishini yuristingiz bilan tekshiring. Texnik tekshiruvlarni esa javobgarlikdan qat'i nazar bajargan ma'qul.",
        },
        {
            q: "Google Analytics va reklama pikselidan voz kechish kerakmi?",
            a: "Voz kechish shart emas, lekin ularning qachon ishga tushishini boshqarish kerak. Ko'p saytda tahlil va reklama skriptlari sahifa ochilishi bilan, hech qanday rozilikdan oldin yuklanadi. To'g'ri yechim — skriptlarni rozilik berilgandan keyin ishga tushirish va qaysi skriptlar ishlayotganini muntazam tekshirib turish.",
        },
    ],

    cta: {
        h: "Saytingizni oltita tekshiruv bo'yicha bepul ko'rib chiqamiz",
        p:
            "Formalar, skriptlar, maxfiylik sahifasi va ma'lumot saqlanadigan joyni tekshiramiz, so'ng muhimlik bo'yicha tartiblangan tuzatish ro'yxatini beramiz. Yuridik matn kerak bo'lsa, buni ham aytamiz.",
        button: "Bepul tekshiruv so'rash",
    },

    images: [
        {
            src: "/assets/img/blog/shaxsiy-malumotlar-sayt-cover.webp",
            alt: "Sayt aloqa formasi va rozilik belgisi diqqat markazida",
            caption: "Hammasi shu kichik katakdan boshlanadi — u bormi va belgilanmaganmi",
            prompt:
                "Laptop screen showing a website contact form with a consent checkbox highlighted, and a magnifying glass over the privacy policy link; clean minimal UI mockup, blue accent, soft shadow, neutral desk background, no logos or readable copy, 16:9",
        },
        {
            src: "/assets/img/blog/shaxsiy-malumotlar-sayt-oqim.webp",
            alt: "Sayt formasidan CRM, pochta va tahlil xizmatlariga ketadigan ma'lumot yo'li",
            caption: "Bitta formadan keyin ma'lumot kamida to'rt manzilga tarqaladi",
            prompt:
                "Data-flow map of a typical business website: form submission to CRM to email to analytics pixel to third-party ad platform; each hop annotated with a small shield icon indicating consent required; flat vector, blue and amber, 16:9",
        },
        {
            src: "/assets/img/blog/klinika-ishonch.webp",
            alt: "Klinika saytida ishonch elementlari — litsenziya, siyosat va aloqa ma'lumotlari",
            caption: "Maxfiylik eng sezgir bo'lgan sohada ishonch bloklari shunday ko'rinadi",
        },
        {
            src: "/assets/img/blog/shaxsiy-malumotlar-sayt-cheklist.webp",
            alt: "Shaxsiy ma'lumotlar bo'yicha oltita tekshiruv kartochkasi",
            caption: "Oltita tekshiruvni bir hafta ichida o'zingiz o'tkaza olasiz",
            prompt:
                "Six-item audit checklist rendered as a clean card grid: consent text, privacy page, retention period, third-party scripts, data access roles, hosting location; light interface, green check and amber warning states, no logos, 4:3",
        },
    ],

    relatedServices: ["korporativ-saytlar", "texnik-qollab-quvvatlash", "veb-ilovalar"],
    relatedPosts: ["biznesni-raqamlashtirish-talablari-2026", "markirovka-kodi-chekda-2026", "ulgurji-savdo-naqdsiz-hisob-kitob"],
};

const ru = {
    meta: {
        title: "Закон о персональных данных и сайт: 6 проверок",
        description:
            "Соответствует ли форма на вашем сайте требованиям ЗРУ-547? Шесть практических проверок: согласие, политика, срок хранения, скрипты, доступы и локализация.",
        keywords: [
            "закон о персональных данных сайт Узбекистан",
            "политика конфиденциальности сайта Узбекистан",
            "локализация персональных данных сервер",
            "согласие на обработку данных форма",
            "ЗРУ-547 персональные данные",
            "хостинг в Узбекистане для сайта",
        ],
    },
    h1: "Нарушает ли форма на вашем сайте закон: шесть практических проверок",
    lead:
        "Любая компания, которая собирает через сайт номер телефона, обрабатывает персональные данные. Разбираем шесть конкретных проверок в контексте требований ЗРУ-547, стоимость исправления каждой и изменение правила локализации, принятое в марте 2026 года.",
    category: "Закон и комплаенс",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "Многие владельцы сайтов рассуждают так: «у нас просто форма обратной связи». На деле через эту форму собираются имя, телефон, иногда адрес; они попадают в CRM, уходят на почту и через аналитические скрипты — к третьим сторонам.",
        },
        {
            type: "p",
            text:
                "Ниже шесть проверок. Провести их можно самостоятельно примерно за час. Для каждой указан объём работ на исправление и ориентировочная цена.",
        },

        { type: "h2", text: "Владелец сайта тоже считается оператором?" },
        {
            type: "p",
            text:
                "Закон «О персональных данных» № ЗРУ-547 от 2 июля 2019 года регулирует обработку персональных данных. Если вы собираете через сайт имя и телефон физического лица, храните их и используете, вы являетесь стороной, которая обрабатывает эти данные.",
        },
        {
            type: "p",
            text:
                "Это не зависит от размера компании. Студия из трёх человек и завод на сотню сотрудников подчиняются одному правилу. Разница только в объёме: чем больше данных, тем дороже обходится ошибка.",
        },
        {
            type: "callout",
            text:
                "Эта статья не является юридическим заключением. Действующую редакцию закона и её применение к вашему случаю проверьте со своим юристом. Здесь разобрана техническая и организационная сторона.",
        },

        { type: "h2", text: "Куда на самом деле уходят данные" },
        {
            type: "p",
            text:
                "На типичном бизнес-сайте после отправки формы данные не остаются в одном месте. Они расходятся минимум по четырём-пяти адресам, и владелец сайта часто не знает половины этой цепочки.",
        },
        {
            type: "ol",
            items: [
                "Форма отправляет данные на сервер сайта, где они записываются в базу.",
                "Тут же уведомление уходит на корпоративную почту или в группу Telegram.",
                "В CRM создаётся новая заявка — нередко это облачный сервис за рубежом.",
                "Аналитический скрипт и рекламный пиксель отправляют данные о поведении на странице.",
                "На части сайтов содержимое формы передаётся ещё и в чат-бот или сервис обзвона.",
            ],
        },
        {
            type: "p",
            text:
                "Каждая стрелка — отдельное решение. Пользователь должен понимать, на какие из них он дал согласие, а вы должны уметь это показать.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Шесть проверок" },
        {
            type: "table",
            head: ["Проверка", "На что смотрим", "Типичная проблема"],
            rows: [
                [
                    "1. Согласие",
                    "Есть ли в форме неотмеченный по умолчанию чекбокс и понятен ли его текст",
                    "Чекбокса нет вовсе или он отмечен заранее",
                ],
                [
                    "2. Политика конфиденциальности",
                    "Есть ли отдельная страница с описанием того, кто, что, зачем и как долго собирает",
                    "Страница скопирована с чужого сайта и не относится к компании",
                ],
                [
                    "3. Срок хранения",
                    "Сколько заявка живёт в CRM и кто её удаляет",
                    "База не чистилась ни разу с 2019 года",
                ],
                [
                    "4. Сторонние скрипты",
                    "Какие аналитические и рекламные скрипты работают на странице",
                    "Скрипты загружаются до получения согласия",
                ],
                [
                    "5. Доступы",
                    "Кто имеет доступ к базе и закрыт ли доступ уволенных сотрудников",
                    "Право полного экспорта есть у всех менеджеров",
                ],
                [
                    "6. Размещение",
                    "В какой стране находятся серверы сайта и CRM",
                    "Точного ответа не может дать никто",
                ],
            ],
        },
        { type: "h3", text: "Проверка 1: текст согласия" },
        {
            type: "p",
            text:
                "В форме должен быть чекбокс согласия, и по умолчанию он остаётся неотмеченным. В тексте нужно ясно указать, зачем собираются данные и кому они передаются. Общей фразы «согласен с условиями» недостаточно — пользователь должен понимать, на что именно соглашается.",
        },
        { type: "h3", text: "Проверка 2: страница политики конфиденциальности" },
        {
            type: "p",
            text:
                "Страница должна находиться на самом сайте, а ссылка на неё — стоять в постоянном месте. В ней указываются название и реквизиты компании, виды собираемых данных, цель, срок хранения и канал связи. Скопированный с чужого сайта текст — самая частая ошибка: в нём обычно остаётся чужое название.",
        },
        { type: "h3", text: "Проверка 3: срок хранения" },
        {
            type: "p",
            text:
                "Данные не должны храниться бесконечно. Практичное решение: задать срок для каждой категории — например, незакрытая заявка — 12 месяцев, карточка клиента — определённый срок после завершения договора. По истечении срока запись автоматически архивируется или удаляется.",
        },
        { type: "h3", text: "Проверка 4: сторонние скрипты" },
        {
            type: "p",
            text:
                "Увидеть, какие скрипты работают на странице, можно в панели разработчика браузера. На многих сайтах аналитика и рекламные пиксели загружаются сразу при открытии страницы, до всякого согласия. Правильное решение — запускать такие скрипты только после согласия.",
        },
        { type: "h3", text: "Проверка 5: у кого есть доступ к базе" },
        {
            type: "p",
            text:
                "Проверьте, сколько сотрудников может выгрузить всю клиентскую базу. Ответ обычно оказывается больше ожидаемого. Разделите роли, ограничьте право экспорта и внесите закрытие доступов уволенным сотрудникам в обязательный чек-лист.",
        },
        { type: "h3", text: "Проверка 6: на каком сервере данные" },
        {
            type: "p",
            text:
                "Выясните точно, в какой стране находятся хостинг сайта, ваша CRM и почтовый сервис. Если ответ «не знаю», это уже отдельная проблема — потому что требование из следующего раздела зависит именно от этого ответа.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Как изменилось требование локализации в 2026 году?" },
        {
            type: "p",
            text:
                "Законом № ЗРУ-1125 от 26 марта 2026 года статья 27-1 закона ЗРУ-547 изложена в новой редакции. В ней прямо перечислены данные, подлежащие обязательному хранению на территории Узбекистана: биометрические данные физических лиц, генетические данные физических лиц и данные пользователей услуг операторов телекоммуникаций, действующих в Узбекистане.",
        },
        {
            type: "p",
            text:
                "Остальные персональные данные могут обрабатываться за пределами страны при выполнении условий, предусмотренных законом. Одновременно новая редакция статьи 20 предусматривает регистрацию баз, подлежащих обязательному хранению в стране, в Государственном реестре.",
        },
        {
            type: "p",
            text:
                "Практический вывод для обычного бизнес-сайта такой. Если вы собираете только имя и телефон и не работаете с биометрическими или генетическими данными, использование зарубежного облака не запрещено автоматически — но требуется выполнить условия, установленные законом. Если же вы работаете с биометрией, например с распознаванием лица на входе, вопрос ставится совершенно иначе.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Сколько стоит исправление и сколько занимает?" },
        {
            type: "p",
            text:
                "Диапазоны ниже — типичный объём работ из практики Innobek. Точная сумма зависит от того, как собран ваш сайт и какая у вас CRM.",
        },
        {
            type: "table",
            head: ["Работа", "Объём", "Ориентировочная цена"],
            rows: [
                ["Добавить в форму чекбокс согласия и понятный текст", "2–4 часа", "до 1 млн сум"],
                ["Разместить страницу политики и связать её ссылками", "4–8 часов", "1–2 млн сум"],
                ["Задать срок хранения и правило автоархивации в CRM", "8–16 часов", "2–4 млн сум"],
                ["Аудит скриптов и их запуск только после согласия", "16–40 часов", "4–10 млн сум"],
                ["Перестройка ролей и прав на экспорт", "8–24 часа", "2–6 млн сум"],
                ["Перенос хостинга или базы на другой сервер", "1–3 недели", "3–8 млн сум"],
                ["Постоянная техническая поддержка", "ежемесячно", "от 3,5 млн сум в месяц"],
            ],
        },
        {
            type: "p",
            text:
                "В цену не входят: подготовка и проверка юридического текста, подписка на новый хостинг или облако, отдельные требования для систем, работающих с биометрией. Текст политики лучше готовить юристу — разработчик только размещает его.",
        },

        { type: "h2", text: "Какой штраф? Честный ответ" },
        {
            type: "p",
            text:
                "Цифры штрафов, которые ходят по интернету, не совпадают между собой, и многие из них опираются на устаревшее значение базовой расчётной величины. Поэтому конкретную сумму мы здесь не приводим.",
        },
        {
            type: "p",
            text:
                "Правильный шаг другой: уточните действующий размер ответственности и его применимость к вашему случаю у своего юриста. С технической стороны шесть проверок выше стоит выполнить независимо от размера штрафа — они снижают и риск утечки данных.",
        },

        { type: "h2", text: "Цена бездействия" },
        {
            type: "list",
            items: [
                "Утечка клиентской базы — репутационный удар, который не исправить быстро никаким бюджетом.",
                "Уволившийся менеджер выгружает базу — ваша воронка продаж оказывается у конкурента.",
                "Корпоративный клиент или организатор тендера запрашивает политику конфиденциальности, и её отсутствие срывает договор.",
                "Если согласие нигде не зафиксировано, вы не сможете подтвердить законность получения данных.",
                "Бесконечно растущая база — это ответственность и за те данные, которые вам давно не нужны.",
            ],
        },

        { type: "h2", text: "Когда эта работа избыточна" },
        {
            type: "list",
            items: [
                "На сайте вообще нет форм и указан только телефон — большая часть описанных работ пока не нужна.",
                "Сайт в ближайшее время переделывается — не правьте старый, внесите требования в техзадание нового.",
                "Внутри нет ответственного — документы появятся, а процесс работать не будет. Сначала назначьте человека.",
                "Вы не используете аналитические скрипты — четвёртая проверка к вам не относится.",
                "Переносите базу на другой сервер, только если этого требует результат шестой проверки. Иначе это лишние расходы.",
            ],
        },

        { type: "h2", text: "План аудита на неделю" },
        {
            type: "ol",
            items: [
                "День 1: составьте список всех форм на сайте — контакты, обратный звонок, скачивание, подписка.",
                "День 2: проследите, куда уходят данные каждой формы, и нарисуйте цепочку.",
                "День 3: прочитайте текст политики конфиденциальности и убедитесь, что в нём не осталось чужого названия.",
                "День 4: найдите самую старую запись в CRM и пропишите правило срока хранения.",
                "День 5: составьте список сотрудников с доступом к базе и закройте лишние.",
                "День 6: письменно выясните, в какой стране находятся ваш хостинг, CRM и почтовый сервис.",
                "День 7: покажите результат юристу и упорядочите список исправлений по важности.",
            ],
        },
        {
            type: "p",
            text:
                "Самая большая польза приходит на второй день. Многие компании впервые видят свою цепочку данных целиком именно тогда — и в тот же день отключают половину лишних скриптов.",
        },
    ],

    faq: [
        {
            q: "У меня на сайте просто форма обратной связи — закон меня касается?",
            a: "Да. Если через форму вы собираете имя и телефон физического лица и храните их, вы обрабатываете персональные данные. Размер компании здесь роли не играет: студия из трёх человек и крупный завод подчиняются одному правилу. Разница только в объёме данных и, соответственно, в уровне риска.",
        },
        {
            q: "Обязательно ли хранить данные на сервере в Узбекистане?",
            a: "Законом № ЗРУ-1125 от 26 марта 2026 года статья 27-1 закона ЗРУ-547 изложена в новой редакции. В ней прямо перечислены данные, подлежащие обязательному хранению в стране: биометрические, генетические и данные пользователей услуг операторов телекоммуникаций. Прочие данные могут обрабатываться за рубежом при выполнении условий закона. Действующую редакцию проверьте с юристом.",
        },
        {
            q: "Можно ли скопировать политику конфиденциальности с другого сайта?",
            a: "Это самая частая ошибка. В скопированном тексте обычно остаются чужое название и сервисы, которыми вы не пользуетесь, то есть документ не описывает ваш реальный процесс. Текст должен отражать реквизиты вашей компании, виды собираемых данных и сроки хранения. Готовить его лучше юристу.",
        },
        {
            q: "Можно ли заранее отметить чекбокс согласия?",
            a: "Нет. Согласие должно быть осознанным действием пользователя, поэтому чекбокс остаётся неотмеченным по умолчанию. Текст тоже должен быть понятным: зачем собираются данные и кому они передаются. Общая формулировка «согласен с условиями» этому требованию не отвечает, потому что пользователь не понимает, на что именно соглашается.",
        },
        {
            q: "Какой штраф предусмотрен?",
            a: "Цифры в открытых источниках расходятся между собой, и многие опираются на устаревшее значение базовой расчётной величины, поэтому конкретную сумму мы не приводим. Уточните действующий размер ответственности и его применимость к вашему случаю у юриста. Технические проверки стоит выполнить независимо от размера санкции.",
        },
        {
            q: "Нужно ли отказываться от Google Analytics и рекламных пикселей?",
            a: "Отказываться не обязательно, но нужно управлять моментом их запуска. На многих сайтах аналитика и рекламные пиксели загружаются сразу при открытии страницы, до всякого согласия. Правильное решение — запускать такие скрипты после получения согласия и регулярно проверять, какие скрипты вообще работают.",
        },
    ],

    cta: {
        h: "Бесплатно проверим ваш сайт по шести пунктам",
        p:
            "Посмотрим формы, скрипты, страницу политики и место хранения данных, затем дадим список исправлений, упорядоченный по важности. Если нужен юридический текст, скажем и об этом.",
        button: "Запросить проверку",
    },

    images: [
        {
            src: "/assets/img/blog/shaxsiy-malumotlar-sayt-cover.webp",
            alt: "Форма обратной связи на сайте с выделенным чекбоксом согласия",
            caption: "Всё начинается с маленького чекбокса: есть ли он и не отмечен ли заранее",
            prompt:
                "Laptop screen showing a website contact form with a consent checkbox highlighted, and a magnifying glass over the privacy policy link; clean minimal UI mockup, blue accent, soft shadow, neutral desk background, no logos or readable copy, 16:9",
        },
        {
            src: "/assets/img/blog/shaxsiy-malumotlar-sayt-oqim.webp",
            alt: "Маршрут данных от формы сайта к CRM, почте и аналитическим сервисам",
            caption: "После одной формы данные расходятся минимум по четырём адресам",
            prompt:
                "Data-flow map of a typical business website: form submission to CRM to email to analytics pixel to third-party ad platform; each hop annotated with a small shield icon indicating consent required; flat vector, blue and amber, 16:9",
        },
        {
            src: "/assets/img/blog/klinika-ishonch.webp",
            alt: "Элементы доверия на сайте клиники — лицензия, политика и контакты",
            caption: "Так выглядят блоки доверия в отрасли, где приватность особенно чувствительна",
        },
        {
            src: "/assets/img/blog/shaxsiy-malumotlar-sayt-cheklist.webp",
            alt: "Шесть карточек проверки по персональным данным",
            caption: "Шесть проверок можно пройти самостоятельно за неделю",
            prompt:
                "Six-item audit checklist rendered as a clean card grid: consent text, privacy page, retention period, third-party scripts, data access roles, hosting location; light interface, green check and amber warning states, no logos, 4:3",
        },
    ],

    relatedServices: ["korporativ-saytlar", "texnik-qollab-quvvatlash", "veb-ilovalar"],
    relatedPosts: ["biznesni-raqamlashtirish-talablari-2026", "markirovka-kodi-chekda-2026", "ulgurji-savdo-naqdsiz-hisob-kitob"],
};

const content = { uz, ru };

export default content;
